import React from 'react';
import { motion } from 'framer-motion';
import { STATS, CARD_RISE } from './data';

export const StatStrip = () => (
  <section className="bg-foreground py-20 text-background md:py-24" data-testid="stat-strip">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <div className="grid items-center gap-12 md:grid-cols-2">
        <div>
          <p className="mb-3 text-sm font-semibold uppercase tracking-[0.2em] text-accent">The experience layer</p>
          <h2 className="font-display text-3xl font-bold tracking-tight text-background sm:text-4xl">
            The gift was never the point — <span className="text-primary">the moment is.</span>
          </h2>
          <p className="mt-5 max-w-md text-base leading-relaxed text-background/70">
            A UNWP is your photos, videos and words wrapped in a mystery countdown — a surprise
            worth remembering, with or without a gift card attached. And when you do add one?
            £7 billion of gift cards change hands in the UK every year, and almost none are
            remembered a week later. UNWP makes yours the exception.
          </p>
        </div>
        <div className="grid gap-4 sm:grid-cols-3">
          {STATS.map((s, i) => (
            <motion.div
              key={s.value}
              {...CARD_RISE}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="rounded-2xl border border-background/10 bg-background/5 p-6"
              data-testid={`stat-${i}`}
            >
              <div className="font-display text-4xl font-bold text-accent">{s.value}</div>
              <p className="mt-2 text-sm leading-snug text-background/70">{s.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
